(ns app.front.view.inspections.section
  (:require [app.front.entities :as entities]
            [app.front.process :as process]
            [app.front.view.inspections.add :as inspection-add]
            [app.front.view.inspections.booking-dialog :as booking-dialog]
            [app.front.view.inspections.list :as inspection-list]
            [app.front.view.workspace.section :as ws-section]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [re-frame.core-instrumented :as rf]))


(rf/reg-sub ::inspections-raw
  :<- [::entities/context]
  (fn [ctx [_ target-id]]
    (->> (entities/find-entities ctx {:entity/type   :entity.type/inspection
                                      :entity/parent target-id})
         (sort-by :ordered/order <))))


(def inspection-has-events?
  (comp seq :entity/_parent))


(rf/reg-sub ::inspections-shown
  (fn [[_ target-id]]
    (rf/subscribe [::inspections-raw target-id]))
  (fn [inspections _]
    (split-with inspection-has-events? inspections)))


(rf/reg-sub ::inspection-section-visible?
  (fn [[_ target]]
    [(rf/subscribe [::process/signal-permitted? target [:process.signal/add-inspection]])
     (rf/subscribe [::inspections-raw (:db/id target)])
     (rf/subscribe [::ff/enabled? :feature-flag.id/inspection-ui-improvements])
     (rf/subscribe [::inspection-add/adding?])])
  (fn [[permitted? inspections ui-improvements? adding?] _]
    (let [has-inspections? (seq inspections)]
      (if ui-improvements?
        (or has-inspections? adding?)
        (or permitted? has-inspections?)))))


(defn inspections-section [{:keys [tr target-entity section-id] :as state}]
  (when (<sub [::inspection-section-visible? target-entity])
    (let [[past-inspections future-inspections] (<sub [::inspections-shown (:db/id target-entity)])
          on-create-booking                     (fn [inspection] (>evt [::booking-dialog/new-booking inspection]))
          group-tz                              (<sub [::ws-subs/group-time-zone])]
      [ws-section/section
       target-entity
       (or section-id :application-inspections)
       state
       :verdict.section.type/inspections
       false
       [:<> {:key "inspections"}
        (when-not (= date-util/browser-timezone group-tz)
          [:div.mb-4 (tr [:inspection/time-zone-info] [group-tz])])
        [inspection-list/render-inspection-list state past-inspections future-inspections on-create-booking]
        [booking-dialog/render-booking-modal tr target-entity]]])))
